<div class="dash-main-content">
  <div class="profil">
    <div class="profil-aside">
      <!-- <app-loader [loading]="loading"></app-loader> -->
      <div class="profil-aside-title m-b-0">
        <h4 class="m-b-8">{{ user?.firstName }} {{ user?.lastName }}</h4>

        <div class="flex gap-8 align-center justify-center m-b-16">
          <!-- <div class="badge neutral">Admin</div> -->
          <div class="badge" [ngClass]="user?.enabled ? 'success' : 'danger'">
            {{ user?.enabled ? 'Actif' : 'Inactif' }}
          </div>
          <div class="badge" [ngClass]="user?.emailVerified ? 'success' : 'warning' ">
            {{user?.emailVerified? 'Email vérifié': 'Email non vérifié'}}
          </div>
        </div>
      </div>

      <div class="infos-user">
        <!-- Username -->
        <div class="flex gap-8 align-center m-b-8">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="#8D9495" stroke-width="1.5" stroke-linecap="round" />
            <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="#8D9495" stroke-width="1.5"
              stroke-linecap="round" />
          </svg>
          <span class="text-gray">{{ user?.username || '—' }}</span>
        </div>

        <!-- Email -->
        <div class="flex gap-8 align-center m-b-8">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5" stroke="#8D9495"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
              stroke="#8D9495" stroke-width="1.5" stroke-linejoin="round" />
          </svg>
          <span class="text-gray">{{ user?.email }}</span>
        </div>

        <!-- Date de création -->
        <div class="flex gap-8 align-center m-b-8">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="#8D9495" stroke-width="1.5" />
            <path d="M3 10h18M8 3v4M16 3v4" stroke="#8D9495" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span class="text-gray">Inscrit le {{ getCreationDate() }}</span>
        </div>
      </div>

      <!-- Rattachement : IES + Établissements -->
      @if (hasRattachement()) {
      <div class="profil-aside-item">
        <div class="flex align-center gap-8 text-gray">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span>Rattachement</span>
        </div>
        <ul class="profil-aside-list">
          @if (user?.sigleIes) {
          <li>
            <span>IES</span>
            <div class="text-blue fw-500" [class.is-loading]="isResolvingIes">
              @if (isResolvingIes) {
              <span class="inline-skeleton" aria-label="Résolution IES…"></span>
              } @else {
              {{ iesDisplayLabel || user?.sigleIes }}
              }
            </div>
          </li>
          }
          @if (user?.sigleEtablissements && user!.sigleEtablissements!.length > 0) {
          <li>
            <span>Établissement(s)</span>
            <div class="text-blue fw-500">
              @if (isResolvingEtab) {
              <span class="inline-skeleton" aria-label="Résolution établissement…"></span>
              } @else {
              {{ getEtablissementsLabel() }}
              }
            </div>
          </li>
          }
        </ul>
      </div>
      }

      <div class="profil-aside-item">
        <div class="flex align-center gap-8 text-gray">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.5 16.5C9.19863 15.2923 10.5044 14.4797 12 14.4797C13.4956 14.4797 14.8014 15.2923 15.5 16.5M14 10C14 11.1046 13.1046 12 12 12C10.8955 12 10 11.1046 10 10C10 8.89543 10.8955 8 12 8C13.1046 8 14 8.89543 14 10Z"
              stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" />
            <path
              d="M22 13.9669V10.0332C19.1433 10.0332 17.2857 6.93041 18.732 4.46691L15.2679 2.5001C13.8038 4.99405 10.1978 4.99395 8.73363 2.5L5.26953 4.46681C6.71586 6.93035 4.85673 10.0332 2 10.0332V13.9669C4.85668 13.9669 6.71425 17.0697 5.26795 19.5332L8.73205 21.5C10.1969 19.0048 13.8046 19.0047 15.2695 21.4999L18.7336 19.5331C17.2874 17.0696 19.1434 13.9669 22 13.9669Z"
              stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Configurations globales</span>
        </div>
        <ul class="profil-aside-list">
          <li>
            <span>Statut du compte</span>
            <form>
              <label class="switch">
                <input type="checkbox" class="open-modal" [checked]="$safeNavigationMigration(user?.enabled)">
                <span class="slider round"></span>
              </label>
              <span>{{ user?.enabled ? 'Activé' : 'Désactivé' }}</span>
            </form>
          </li>
          <li>
            <span>Réinitialiser mot de passe</span>
            <button (click)="onResetPassword(user!)" class="button-no-style button-text-green"
              [disabled]="processingActions.has('reset')">
              @if (processingActions.has('reset')) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              Envoyer
            </button>
          </li>
          <li>
            <span>Renvoyer mail de vérification</span>
            <button (click)="sendEmailVerification(user!)" class="button-no-style button-text-green"
              [disabled]="processingActions.has('verify') || user?.emailVerified">
              @if (processingActions.has('verify')) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              Envoyer
            </button>
          </li>
        </ul>
      </div>
      <div class="profil-aside-item">
        <div class="flex align-center gap-8 text-gray">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 18C2 16.4596 2 15.6893 2.34673 15.1235C2.54074 14.8069 2.80693 14.5407 3.12353 14.3467C3.68934 14 4.45956 14 6 14C7.54044 14 8.31066 14 8.87647 14.3467C9.19307 14.5407 9.45926 14.8069 9.65327 15.1235C10 15.6893 10 16.4596 10 18C10 19.5404 10 20.3107 9.65327 20.8765C9.45926 21.1931 9.19307 21.4593 8.87647 21.6533C8.31066 22 7.54044 22 6 22C4.45956 22 3.68934 22 3.12353 21.6533C2.80693 21.4593 2.54074 21.1931 2.34673 20.8765C2 20.3107 2 19.5404 2 18Z"
              stroke="#5C6465" stroke-width="1.5" />
            <path
              d="M14 18C14 16.4596 14 15.6893 14.3467 15.1235C14.5407 14.8069 14.8069 14.5407 15.1235 14.3467C15.6893 14 16.4596 14 18 14C19.5404 14 20.3107 14 20.8765 14.3467C21.1931 14.5407 21.4593 14.8069 21.6533 15.1235C22 15.6893 22 16.4596 22 18C22 19.5404 22 20.3107 21.6533 20.8765C21.4593 21.1931 21.1931 21.4593 20.8765 21.6533C20.3107 22 19.5404 22 18 22C16.4596 22 15.6893 22 15.1235 21.6533C14.8069 21.4593 14.5407 21.1931 14.3467 20.8765C14 20.3107 14 19.5404 14 18Z"
              stroke="#5C6465" stroke-width="1.5" />
            <path
              d="M2 6C2 4.45956 2 3.68934 2.34673 3.12353C2.54074 2.80693 2.80693 2.54074 3.12353 2.34673C3.68934 2 4.45956 2 6 2C7.54044 2 8.31066 2 8.87647 2.34673C9.19307 2.54074 9.45926 2.80693 9.65327 3.12353C10 3.68934 10 4.45956 10 6C10 7.54044 10 8.31066 9.65327 8.87647C9.45926 9.19307 9.19307 9.45926 8.87647 9.65327C8.31066 10 7.54044 10 6 10C4.45956 10 3.68934 10 3.12353 9.65327C2.80693 9.45926 2.54074 9.19307 2.34673 8.87647C2 8.31066 2 7.54044 2 6Z"
              stroke="#5C6465" stroke-width="1.5" />
            <path
              d="M14 6C14 4.45956 14 3.68934 14.3467 3.12353C14.5407 2.80693 14.8069 2.54074 15.1235 2.34673C15.6893 2 16.4596 2 18 2C19.5404 2 20.3107 2 20.8765 2.34673C21.1931 2.54074 21.4593 2.80693 21.6533 3.12353C22 3.68934 22 4.45956 22 6C22 7.54044 22 8.31066 21.6533 8.87647C21.4593 9.19307 21.1931 9.45926 20.8765 9.65327C20.3107 10 19.5404 10 18 10C16.4596 10 15.6893 10 15.1235 9.65327C14.8069 9.45926 14.5407 9.19307 14.3467 8.87647C14 8.31066 14 7.54044 14 6Z"
              stroke="#5C6465" stroke-width="1.5" />
          </svg>
          <span>Applications & rôles</span>
        </div>
        <ul class="profil-aside-list">
          <li>
            <span>Applications</span>
            <div class="text-blue">{{ getUserApps().length }}</div>
          </li>
          <li>
            <span>Nombre de rôle</span>
            <div class="text-blue">{{totalRolesCount}}</div>
          </li>
        </ul>
      </div>
      <div class="two-buttons">
        <button class="button neutral rounded"
          [routerLink]="['/dashboard/users', $safeNavigationMigration(user?.id), 'edit']">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
              stroke="#263435" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M13 4L20 11" stroke="#263435" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M14 22L22 22" stroke="#263435" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Modifier</span>
        </button>
      </div>
    </div>

    <div class="profil-content">
      <div class="tabs">
        <div class="tab-list" role="tablist" aria-label="Gestion des utilisateurs">
          <!-- Tab 2 -->
          <button role="tab" [attr.aria-selected]="activeTab === 2 ? 'true' : 'false'" aria-controls="panel-2"
            id="tab-2" (click)="switchTab(2)" [class.active]="activeTab === 2">
            Rôles attribués
          </button>

          <!-- Tab 3 -->
          <button role="tab" [attr.aria-selected]="activeTab === 3 ? 'true' : 'false'" aria-controls="panel-3"
            id="tab-3" (click)="switchTab(3)" [class.active]="activeTab === 3">
            Événements administrateurs
          </button>

          <!-- Tab 1 — Groupes -->
          <button role="tab" [attr.aria-selected]="activeTab === 1 ? 'true' : 'false'" aria-controls="panel-1"
            id="tab-1" (click)="switchTab(1)" [class.active]="activeTab === 1">
            Groupes
          </button>
        </div>

        <div class="tab-panels">
          <!-- Panel 2 – Rôles attribués -->
          @if (activeTab === 2) {
          <div id="panel-2" class="tab-panel" [class.active]="activeTab === 2" role="tabpanel"
            [attr.aria-labelledby]="'tab-2'">
            <div class="flex align-center justify-between gap-8 flex-wrap m-b-24">
              <h4 class="m-b-4">Rôles attribués</h4>
              @if (userAppsWithRoles) {
              <span class="text-muted">
                {{ totalRolesCount }} rôle{{ totalRolesCount > 1 ? 's' : '' }}
                sur {{ getUserApps().length }} application{{ getUserApps().length > 1 ? 's' : '' }}
              </span>
              }
            </div>
            <!-- Skeleton de chargement -->
            @if (loadingAppsWithRoles) {
            <div class="skeleton-container">
              <div class="skeleton-table">
                <div class="skeleton-row skeleton-header">
                  <div class="skeleton-cell" style="width: 40%;"></div>
                  <div class="skeleton-cell" style="width: 60%;"></div>
                </div>
                @for (_ of [1,2,3]; track _) {
                <div class="skeleton-row">
                  <div class="skeleton-cell" style="width: 35%;"></div>
                  <div class="skeleton-cell" style="width: 55%;"></div>
                </div>
                }
              </div>
            </div>
            }
            <!-- Grille des applications -->
            @if (!loadingAppsWithRoles && userAppsWithRoles) {
            <div class="apps-grid">
              @for (app of (userAppsWithRoles | keyvalue); track trackByAppKey($index, app)) {
              <div class="app-card" [class.open]="expandedApp === app.key">
                <!-- En-tête cliquable -->
                <div class="app-card-header" (click)="toggleApp(app.key)">
                  <span class="app-name">{{ app.key }}</span>
                  <span class="app-badge">
                    {{ Object.keys(app.value).length }}
                  </span>
                  <span class="app-arrow" [class.open]="expandedApp === app.key">▼</span>
                </div>
                <!-- Corps déroulant : liste des rôles -->
                <div class="app-card-body" [class.open]="expandedApp === app.key">
                  @if (Object.keys(app.value).length > 0) {
                  <div class="roles-container">
                    @for (role of (app.value | keyvalue); track role) {
                    <span class="role-tag">
                      {{ role.value.title || role.value.name }}
                    </span>
                    }
                  </div>
                  }
                  @if (Object.keys(app.value).length === 0) {
                  <div class="no-roles">
                    Aucun rôle
                  </div>
                  }
                </div>
              </div>
              }
              <!-- Message si aucune application -->
              @if (!userAppsWithRoles || Object.keys(userAppsWithRoles).length === 0) {
              <div class="text-center text-muted p-24">
                Aucune application trouvée
              </div>
              }
            </div>
            }
          </div>
          }

          <!-- Panel 3 -->
          @if (activeTab === 3) {
          <div id="panel-3" class="tab-panel" [class.active]="activeTab === 3" role="tabpanel"
            [attr.aria-labelledby]="'tab-3'">
            <div class="flex align-center justify-between gap-8 flex-wrap m-b-24">
              <h4 class="m-b-4">Événements administrateurs</h4>
              <div class="field-search-btn">
                <input type="text" placeholder="Rechercher" class="search-icon" [(ngModel)]="searchTerm"
                  (ngModelChange)="filterHistory()" [disabled]="isLoadingEvents">
                <button type="button" [disabled]="isLoadingEvents">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.0003 11.9998L4.00024 11.9998" stroke="#1E1F24" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0003 10.6824 15.0002 7 15.0002 7"
                      stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <!-- Skeleton pour l'historique -->
            @if (isLoadingEvents) {
            <div class="skeleton-container">
              <div class="skeleton-table">
                <div class="skeleton-row skeleton-header">
                  <div class="skeleton-cell" style="width: 20%;"></div>
                  <div class="skeleton-cell" style="width: 20%;"></div>
                  <div class="skeleton-cell" style="width: 30%;"></div>
                  <div class="skeleton-cell" style="width: 30%;"></div>
                </div>
                @for (_ of [1,2,3,4]; track _) {
                <div class="skeleton-row">
                  <div class="skeleton-cell" style="width: 20%;"></div>
                  <div class="skeleton-cell" style="width: 20%;"></div>
                  <div class="skeleton-cell" style="width: 30%;"></div>
                  <div class="skeleton-cell" style="width: 30%;"></div>
                </div>
                }
              </div>
            </div>
            }
            <!-- Message si aucun résultat -->
            @if (filteredEvents.length === 0 && !isLoadingEvents) {
            <div class="no-results-message">
              Aucun événement administrateurs trouvé.
            </div>
            }
            <!-- Tableau dynamique -->
            @if (!isLoadingEvents) {
            <div>
              @if (filteredEvents.length > 0) {
              <table class="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Action</th>
                    <th>Détail</th>
                    <th>Acteur</th>
                  </tr>
                </thead>
                <tbody>
                  @for (event of filteredEvents; track event) {
                  <tr>
                    <td>
                      <time class="activities-date" [attr.datetime]="event.timestamp | date:'yyyy-MM-ddTHH:mm'">
                        {{ event.timestamp | date:'dd MMMM yyyy' }}
                        <span>à {{ event.timestamp | date:'HH:mm' }}</span>
                      </time>
                    </td>
                    <td>
                      <div class="badge" [ngClass]="getActionBadgeClass(event.operationType)">
                        {{ getActionLabel(event.operationType) }}
                      </div>
                    </td>
                    <td>
                      <span class="activities-own">{{ getEventDetail(event) }}</span>
                    </td>
                    <td>
                      <strong>{{ getActorName(event) }}</strong>
                      @if (getActorEmail(event)) {
                      <div class="text-gray small">
                        {{ getActorEmail(event) }}
                      </div>
                      }
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              }
            </div>
            }
          </div>
          }

          <!-- Panel 1 — Groupes -->
          @if (activeTab === 1) {
          <div id="panel-1" class="tab-panel" [class.active]="activeTab === 1" role="tabpanel"
            [attr.aria-labelledby]="'tab-1'">
            <div class="flex align-center justify-between gap-8 flex-wrap m-b-24">
              <h4 class="m-b-4">Groupes</h4>
            </div>
            <!-- Skeleton pour les groupes -->
            @if (isLoadingGroups) {
            <div class="skeleton-container">
              <div class="skeleton-table">
                <div class="skeleton-row skeleton-header">
                  <div class="skeleton-cell" style="width: 40%;"></div>
                  <div class="skeleton-cell" style="width: 60%;"></div>
                </div>
                @for (_ of [1,2,3,4]; track _) {
                <div class="skeleton-row">
                  <div class="skeleton-cell" style="width: 35%;"></div>
                  <div class="skeleton-cell" style="width: 55%;"></div>
                </div>
                }
              </div>
            </div>
            }
            <!-- Message si aucun groupe -->
            @if (!isLoadingGroups && userGroups.length === 0) {
            <div class="no-results-message">
              Aucun groupe assigné à cet utilisateur.
            </div>
            }
            <!-- Tableau — même structure que le tableau de l'historique -->
            @if (!isLoadingGroups && userGroups.length > 0) {
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th>Nom du groupe</th>
                    <th>Path</th>
                  </tr>
                </thead>
                <tbody>
                  @for (group of userGroups; track group) {
                  <tr>
                    <td>
                      <span>{{ group.name }}</span>
                    </td>
                    <td>
                      <span class="text-blue">{{ group.path }}</span>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>